import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { I18nPipeModule } from '@pipes';

import { SharedModule } from '../shared/shared.module';
import { OverviewComponent } from './overview/overview.component';
import { StatisticRoutingModule } from './statistic-routing.module';

@NgModule({
    declarations: [OverviewComponent],
    imports: [CommonModule, SharedModule, StatisticRoutingModule, I18nPipeModule],
})
export class StatisticModule {}
